export default __webpack_public_path__ + "static/media/landing-desktop-01.ddf8aea4.png";